import authAxios from '@services/authAxios';

const fetchSisoTable = async (queries) => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/siso/brands?${queries}`,
    });

    return data?.data;
};

export default fetchSisoTable;
